import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"id":"new_payroll_header","fluid":""}},[_c('v-payroll-header-entry',{attrs:{"payroll_header":_vm.payroll_header,"popup_editors":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }